export default "/images/image_5.jpg?a8ad259cd6c716627dfc97f292573ab8";